import React from 'react'
import { makeStyles, Grid, Box } from '@material-ui/core'
import { useParams } from 'react-router-dom'
import PatientDetailsVitals from '../../components/PatientDetails/PatientDetailVitals'
import OnlineVideo from '../../components/OnlineConsult/OnlineVideo'
import { Layout } from '../../doctorLayouts'
import Arrow from '../../images/next-arrow.png'

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    background: '#16171b',
    margin: 0,
    padding: 0
  },
  MainContent: {
    width: '100%',
    padding: '0',
    marginTop: '10px',
    backgroundColor: '#16171b',
    height: '100vh',
    '& .MuiGrid-item': {
      width: '100%'
    },
    '@media (max-width:991px)': {
      padding: '0px 20px;'
    },
    '@media (max-width:850px)': {
      height: 'auto'
    }
  },
  TabCol: {
    backgroundColor: '#fff',
    height: '100vh',
    overflowY: 'auto',
    paddingBottom: '50px',
    display: 'none',
    transition: 'all 0.75s ease',
    order: 1,
    '@media (max-width:991px)': {
      display: 'block',
      width: '100%'
    }
  },
  VideoCol: {
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    flex: 1,
    '@media (max-width:991px)': {
      width: '100%',
      order: '1'
    }
  },
  HalfWidth: {
    flex: 1
  },
  NextBtn: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    background: 'linear-gradient(to right bottom, #3E3BE8, #3267F1)',
    textAlign: 'center',
    lineHeight: '55px',
    position: 'absolute',
    marginLeft: '30px',
    marginTop: '25px',
    cursor: 'pointer',
    zIndex: '999',
    '& img': {
      height: '16px',
      width: '11px'
    }
  }
}))

export default function TeleConsult() {
  const classes = useStyles()
  const params = useParams()
  const [isVitalsVisible, setVitalsVisible] = React.useState(false)

  const toggleSections = () => {
    setVitalsVisible(prev => !prev)
  }

  return (
    <Layout showLogout={false} hideNavbar={true}>
      <div className={classes.root}>
        <Box className={classes.MainContent}>
          <Grid container spacing={3}>
            <Grid
              id="div1"
              item
              md={6}
              className={`${classes.TabCol} ${
                isVitalsVisible ? classes.HalfWidth : ''
              }`}
              style={{
                display: isVitalsVisible ? 'block' : 'none',
                order: isVitalsVisible ? 1 : 2
              }}>
              <PatientDetailsVitals
                className="patientvitals-table"
                patientId={params.patient_id}
              />
            </Grid>
            <Grid
              id="div2"
              item
              md={6}
              className={`${classes.VideoCol} ${
                isVitalsVisible ? classes.HalfWidth : ''
              }`}
              style={{
                order: isVitalsVisible ? 2 : 1
              }}>
              <button className={classes.NextBtn} onClick={toggleSections}>
                <img src={Arrow} alt="" />
              </button>
              <OnlineVideo appointmentId={params.appointment_id} />
            </Grid>
          </Grid>
        </Box>
      </div>
    </Layout>
  )
}
